import { OperationRefModel } from '../../Models/DomainServiceModel';
import OperationPickerDialog from './OperationPickerDialog';

type OperationInputDialogProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
	operationRef: OperationRefModel | undefined;
	onOperationRefChange: (operationRef: OperationRefModel | undefined) => void;
};

export function OperationInputDialog({ open, setOpen, operationRef, onOperationRefChange }: OperationInputDialogProps) {
	return (
		<OperationPickerDialog
			open={open}
			setOpen={setOpen}
			operationRefs={operationRef ? [operationRef] : undefined}
			onOperationRefsChange={(operationRefs) => onOperationRefChange(operationRefs?.[0])}
		/>
	);
}
